export default function h(tag, props = {}, ...children) {
    if (typeof tag === 'function') return tag(props || {}, children);

    const element = document.createElement(tag);

    for (let [name, value] of Object.entries(props || {})) {
        if (name.startsWith("on") && name.toLowerCase() in window) value && element.addEventListener(name.toLowerCase().substring(2), value);
        else if (typeof value === 'boolean') value && element.setAttribute(name, '');
        else element.setAttribute(name, value && value.toString());
    };

    for (let child of children) { appendChild(element, child); };

    return element;
};

function appendChild(parent, child) {
    if (Array.isArray(child)) for (let nChild of child) appendChild(parent, nChild);
    else if (child) parent.appendChild(child.nodeType ? child : document.createTextNode(child));
};



let to_start_stack = [];
export function render(page, ctx) {
    const element = page({ context: ctx });

    document.body.replaceChildren(element);

    for (let init of to_start_stack) init(ctx);
    
    to_start_stack = [];
};

export function onInit(callback) {
    if (!callback || typeof callback !== 'function') return;
    to_start_stack.push(callback);
};